import { render, staticRenderFns } from "./Depth2Content.vue?vue&type=template&id=57d7832a&scoped=true&"
import script from "./Depth2Content.vue?vue&type=script&lang=js&"
export * from "./Depth2Content.vue?vue&type=script&lang=js&"
import style0 from "./Depth2Content.vue?vue&type=style&index=0&id=57d7832a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7832a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d7832a')) {
      api.createRecord('57d7832a', component.options)
    } else {
      api.reload('57d7832a', component.options)
    }
    module.hot.accept("./Depth2Content.vue?vue&type=template&id=57d7832a&scoped=true&", function () {
      api.rerender('57d7832a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Terms/Depth2Content.vue"
export default component.exports